import { render, staticRenderFns } from "./PollCreate.vue?vue&type=template&id=5a1324a3&scoped=true"
import script from "./PollCreate.vue?vue&type=script&lang=js"
export * from "./PollCreate.vue?vue&type=script&lang=js"
import style0 from "./PollCreate.vue?vue&type=style&index=0&id=5a1324a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1324a3",
  null
  
)

export default component.exports